import React, { useContext, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CompanyContext } from '../../contexts'
import {
  setConfirmCompanyRequestModalVisibility as setConfirmCompanyRequestModalVisibilityAction,
  setCurrentRequest as setCurrentRequestAction,
  setMergeCompanyRequestModalVisibility as setMergeCompanyRequestModalVisibilityAction,
  setRejectCompanyRequestModalVisibility as setRejectCompanyRequestModalVisibilityAction,
} from '../../slices/company_request_slice'

export default function CompanyRequestRow({ request = null }) {
  const dispatch = useDispatch()
  const { activeIndex } = useSelector((state) => state.company)
  const { company_types } = useContext(CompanyContext)
  const company = useMemo(() => request.company_alias?.company, [request])

  const onClickConfirmButton = () => {
    dispatch(setCurrentRequestAction(request))
    dispatch(setConfirmCompanyRequestModalVisibilityAction(true))
  }

  const onClickRejectButton = () => {
    dispatch(setCurrentRequestAction(request))
    dispatch(setRejectCompanyRequestModalVisibilityAction(true))
  }

  const onClickMergeButton = () => {
    dispatch(setCurrentRequestAction(request))
    dispatch(setMergeCompanyRequestModalVisibilityAction(true))
  }

  return (
    <>
      <tr>
        <td>{company.name}</td>
        <td>
          {company.company_aliases.map((alias, key) => (
            <div key={key}>{alias.name}</div>
          ))}
        </td>
        <td>{company.logo_url && <img src={company.logo_url} width={32}></img>}</td>
        <td>{company.company_type}</td>
        <td>{company.status}</td>
        <td>{request.sourceable_type}</td>
        <td>
          <div className="dome-d-flex dome-gap12">
            <PendingCompanyRequestActions
              onClickApprove={onClickConfirmButton}
              onClickReject={onClickRejectButton}
              onClickMerge={onClickMergeButton}
            />
          </div>
        </td>
      </tr>
    </>
  )
}

function PendingCompanyRequestActions({ onClickApprove, onClickReject, onClickMerge }) {
  return (
    <>
      <button className="dome-btn dome-btn-base dome-btn-aqua-stroke" onClick={onClickApprove}>
        Confirm
      </button>
      <button className="dome-btn dome-btn-base dome-btn-grey-stroke" onClick={onClickReject}>
        Reject
      </button>
      <button className="dome-btn dome-btn-base dome-btn-green-stroke" onClick={onClickMerge}>
        Merge
      </button>
    </>
  )
}
